export enum API {
  v1 = 'api/v1',
  v2 = 'api/v2',
}

export enum ProductDetailPath {
  Detail = 'details',
  Drawings = 'drawings',
  Calculations = 'calculations',
  SchaefflerBom = 'bom/schaeffler',
  VitescoBom = 'bom/vitesco',
  CostComponentSplit = 'cost-component-split',
  Pricing = 'pricing',
}

export const ComparisonPath = 'comparison';

export const BomExportPath = 'bom/export';
export const BomExportStatusPath = `${BomExportPath}/status`;
export const BomExportStatusLivePath = `${BomExportStatusPath}/live`;
